import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const BriefcaseBase = (
  <path
    fill='currentColor'
    d='M16.176 12.017v-1.51c0-.838-.66-1.507-1.476-1.507H8.83c-.814 0-1.477.675-1.477 1.507v1.51H4.415c-.814 0-1.474.673-1.474 1.503v9.058c0 .829.66 1.503 1.474 1.503h14.699c.815 0 1.474-.673 1.474-1.503V13.52c0-.829-.66-1.503-1.474-1.503h-2.938zm-7.72 0v-1.318c0-.313.251-.567.553-.567h5.512c.305 0 .553.258.553.567v1.318H8.456z'
  />
)

export const Briefcase = createIcon({
  displayName: 'Briefcase',
  viewBox: '0 0 24 24',
  path: BriefcaseBase,
})
